import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import PropEditorElement from './PropEditorElement';

const PropEditorArrayItem = ({ originalPropname, prop, props, componentId, componentName, arrayIndex }) => {
	return (
		<Box display="flex" flexWrap={'wrap'} m={1} border={'1px solid #E2E8F0'} borderRadius={'10px'}>
			<Text pl={1} fontWeight={'bold'} flexBasis="100%">
				Item {arrayIndex + 1}{' '}
			</Text>
			{Object.keys(prop || {}).map((propName, index) => (
				<PropEditorElement
					{...{ originalPropname, propName, props: prop, componentId, componentName, arrayIndex }}
					key={componentId + '-prop-' + propName + '-array-' + arrayIndex}
				/>
			))}
		</Box>
	);
};

export default PropEditorArrayItem;
